(() => {
  const buildSummary = (items) => items
    .filter((item) => Number(item.quantity) > 0)
    .map((item) => `${item.label}${item.sku ? ` | SKU: ${item.sku}` : ''} | Quantity: ${Number(item.quantity)} yards`)
    .join('\n');

  const cleanSuccessUrl = (href, formId) => {
    const url = new URL(href);

    url.searchParams.delete('contact_posted');
    if (url.hash === '#contact_form' || url.hash === `#${formId}`) {
      url.hash = '';
    }

    return url.toString();
  };

  const setSubmitLoading = (button) => {
    if (!button) {
      return;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
  };

  window.t26WholesaleInquiry = { buildSummary, cleanSuccessUrl, setSubmitLoading };

  if (typeof document === 'undefined') {
    return;
  }

  const t26GetModal = (trigger) => document.getElementById(trigger.getAttribute('aria-controls'));

  const t26CloneVariantVisual = (source) => {
    const visual = source.querySelector('.aspect-ratio');

    return visual ? visual.cloneNode(true) : null;
  };

  const t26UpdateSelectedState = (modal) => {
    const selected = modal.querySelector('[data-t26-wholesale-inquiry-selected]');
    const count = selected.querySelectorAll('[data-t26-wholesale-inquiry-row]').length;

    modal.querySelector('[data-t26-wholesale-inquiry-count]').textContent = `${count} selected`;
    modal.querySelector('[data-t26-wholesale-inquiry-empty]').hidden = count > 0;
  };

  const t26SetDefaultCountry = (modal) => {
    const select = modal.querySelector('[data-t26-wholesale-inquiry-country]');
    const defaultCountry = select && select.dataset.default;

    if (!select) {
      return;
    }

    if (!defaultCountry) {
      select.value = '';
      return;
    }

    const option = Array.from(select.options).find((item) => item.value === defaultCountry || item.textContent.trim() === defaultCountry);

    if (option) {
      select.value = option.value;
    }
  };

  const t26ResetSuccess = (modal) => {
    const success = modal.querySelector('[data-t26-wholesale-inquiry-success]');

    if (!success || success.hidden) {
      return;
    }

    success.hidden = true;
    modal.querySelector('[data-t26-wholesale-inquiry-content]').hidden = false;
    modal.querySelector('[data-t26-wholesale-inquiry-footer]').hidden = false;
    modal.removeAttribute('data-t26-wholesale-inquiry-auto-open');

    const form = modal.closest('form');
    window.history.replaceState({}, '', cleanSuccessUrl(window.location.href, form.id));
  };

  const t26FindSelectedRow = (modal, variantId) => Array.from(modal.querySelectorAll('[data-t26-wholesale-inquiry-row]'))
    .find((row) => row.dataset.variantId === variantId);

  const t26AddSelectedRow = (modal, button) => {
    const selected = modal.querySelector('[data-t26-wholesale-inquiry-selected]');
    const row = document.createElement('div');
    const thumbnail = document.createElement('span');
    const label = document.createElement('span');
    const quantityLabel = document.createElement('label');
    const quantity = document.createElement('input');
    const unit = document.createElement('span');
    const remove = document.createElement('button');
    const visual = t26CloneVariantVisual(button);
    const quantityId = `${modal.id}-quantity-${button.dataset.variantId}`;

    row.className = 't26-wholesale-inquiry__selected-row';
    row.dataset.t26WholesaleInquiryRow = '';
    row.dataset.variantId = button.dataset.variantId;
    row.dataset.variantLabel = button.dataset.variantLabel;
    row.dataset.variantSku = button.dataset.variantSku;

    thumbnail.className = 't26-wholesale-inquiry__selected-thumbnail';
    if (visual) {
      thumbnail.appendChild(visual);
    }

    label.className = 't26-wholesale-inquiry__selected-label';
    label.textContent = button.dataset.variantLabel;

    quantityLabel.className = 'visually-hidden';
    quantityLabel.htmlFor = quantityId;
    quantityLabel.textContent = `Quantity for ${button.dataset.variantLabel} in yards`;

    quantity.id = quantityId;
    quantity.className = 'form__field t26-wholesale-inquiry__quantity';
    quantity.type = 'number';
    quantity.inputMode = 'numeric';
    quantity.min = '1';
    quantity.step = '1';
    quantity.placeholder = '0';
    quantity.required = true;
    quantity.dataset.t26WholesaleInquiryQuantity = '';

    unit.className = 't26-wholesale-inquiry__unit';
    unit.textContent = 'yards';

    remove.className = 't26-wholesale-inquiry__remove';
    remove.type = 'button';
    remove.dataset.t26WholesaleInquiryRemove = '';
    remove.dataset.variantId = button.dataset.variantId;
    remove.setAttribute('aria-label', `Remove ${button.dataset.variantLabel}`);
    remove.textContent = '×';

    row.append(thumbnail, label, quantityLabel, quantity, unit, remove);
    selected.appendChild(row);
  };

  const t26SetVariantSelected = (modal, button, selected) => {
    const existingRow = t26FindSelectedRow(modal, button.dataset.variantId);

    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');

    if (selected && !existingRow) {
      t26AddSelectedRow(modal, button);
    } else if (!selected && existingRow) {
      existingRow.remove();
    }

    modal.querySelector('[data-t26-wholesale-inquiry-selection-error]').hidden = true;
    t26UpdateSelectedState(modal);
  };

  const t26PrepareModal = (trigger) => {
    const modal = t26GetModal(trigger);
    const sourceScope = trigger.closest('product-form');
    const grid = modal && modal.querySelector('[data-t26-wholesale-inquiry-swatches]');

    if (!modal || !sourceScope || !grid || grid.dataset.ready === 'true') {
      return modal;
    }

    sourceScope.querySelectorAll('[data-t26-wholesale-variant-source]').forEach((source) => {
      if (!source.dataset.t26WholesaleVariantId) {
        return;
      }

      const button = document.createElement('button');
      const visual = t26CloneVariantVisual(source);

      button.className = 't26-wholesale-inquiry__swatch';
      button.type = 'button';
      button.dataset.t26WholesaleInquiryVariant = '';
      button.dataset.variantId = source.dataset.t26WholesaleVariantId;
      button.dataset.variantLabel = source.dataset.t26WholesaleVariantLabel || source.title;
      button.dataset.variantSku = source.dataset.t26WholesaleVariantSku || '';
      button.setAttribute('aria-label', `Select ${button.dataset.variantLabel}`);
      button.setAttribute('aria-pressed', 'false');
      if (visual) {
        button.appendChild(visual);
      }

      grid.appendChild(button);
    });

    grid.dataset.ready = 'true';
    t26SetDefaultCountry(modal);
    t26UpdateSelectedState(modal);

    return modal;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-t26-wholesale-inquiry-open]');

    if (trigger) {
      t26PrepareModal(trigger);
      return;
    }

    const swatch = event.target.closest('[data-t26-wholesale-inquiry-variant]');

    if (swatch) {
      const modal = swatch.closest('[data-t26-wholesale-inquiry]');
      t26SetVariantSelected(modal, swatch, swatch.getAttribute('aria-pressed') !== 'true');
      return;
    }

    const remove = event.target.closest('[data-t26-wholesale-inquiry-remove]');

    if (remove) {
      const modal = remove.closest('[data-t26-wholesale-inquiry]');
      const button = Array.from(modal.querySelectorAll('[data-t26-wholesale-inquiry-variant]'))
        .find((item) => item.dataset.variantId === remove.dataset.variantId);

      if (button) {
        t26SetVariantSelected(modal, button, false);
      }
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.t26-wholesale-inquiry__form');

    if (!form) {
      return;
    }

    const modal = form.querySelector('[data-t26-wholesale-inquiry]');
    const items = Array.from(modal.querySelectorAll('[data-t26-wholesale-inquiry-row]')).map((row) => ({
      label: row.dataset.variantLabel,
      sku: row.dataset.variantSku,
      quantity: row.querySelector('[data-t26-wholesale-inquiry-quantity]').value,
    }));
    const summary = buildSummary(items);

    if (!summary) {
      event.preventDefault();
      const error = modal.querySelector('[data-t26-wholesale-inquiry-selection-error]');
      const firstSwatch = modal.querySelector('[data-t26-wholesale-inquiry-variant]');

      error.hidden = false;
      firstSwatch && firstSwatch.focus();
      return;
    }

    modal.querySelector('[data-t26-wholesale-inquiry-summary]').value = summary;
    setSubmitLoading(modal.querySelector('[data-t26-wholesale-inquiry-submit]'));
  });

  document.querySelectorAll('[data-t26-wholesale-inquiry]').forEach((modal) => {
    modal.addEventListener('modal:closed', () => t26ResetSuccess(modal));
  });

  const autoOpenModal = document.querySelector('[data-t26-wholesale-inquiry-auto-open]');

  if (autoOpenModal) {
    const trigger = Array.from(document.querySelectorAll('[data-t26-wholesale-inquiry-open]'))
      .find((item) => item.getAttribute('aria-controls') === autoOpenModal.id);

    if (trigger) {
      t26PrepareModal(trigger);
      trigger.click();
    }
  }
})();
